import { render, staticRenderFns } from "./noneBox.vue?vue&type=template&id=4e08c91f&scoped=true"
import script from "./noneBox.vue?vue&type=script&lang=js"
export * from "./noneBox.vue?vue&type=script&lang=js"
import style0 from "./noneBox.vue?vue&type=style&index=0&id=4e08c91f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08c91f",
  null
  
)

export default component.exports